export default "/public/dist/img/Immagine.png";